export default __webpack_public_path__ + "static/media/loader.8162bf94.gif";